import axios from 'axios';

const getApiUrl = () => {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isLocalNetwork = hostname.startsWith('192.168.') || hostname.startsWith('10.');

    if (isLocalhost || isLocalNetwork) {
        return `http://${hostname}:5000/api`;
    }

    return process.env.REACT_APP_API_URL || `http://${hostname}:5000/api`;
};

const API_URL = getApiUrl();

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL,
    // Глобальный таймаут: закрывает кейс "висит POST, нет ни ответа, ни
    // ошибки" (замечено на печати СДЭК-ярлыков 90015). 30с — компромисс:
    // печать СДЭК + PDF обычно <10с, локальные SQL <1с, но внешние Честный
    // ЗНАК / MS upload могут задуматься дольше. Если такие эндпоинты начнут
    // падать по таймауту — точечно поднимаем per-request override.
    timeout: 30000
})

$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    return config;
})

$api.interceptors.response.use((config) => {
    return config;
},async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status == 401 && error.config && !error.config._isRetry) {
        originalRequest._isRetry = true;
        try {
            const response = await axios.get(`${API_URL}/refresh`, {withCredentials: true})
            localStorage.setItem('token', response.data.accessToken);
            return $api.request(originalRequest);
        } catch (e) {
            // Не авторизован - пользователь будет перенаправлен на логин
        }
    }
    throw error;
})

export default $api;
export { API_URL };
